import axios from "axios";
import { link } from "../config";

axios.defaults.baseURL = link;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // You can access the response status and data here
      const status = error.response.status;
      const data = error.response.data;

      // Handle the error or non-200 response as needed
      console.error(`Request failed with status ${status}:`, data);


    } else {
      // Handle network errors or other issues
      console.error("Network error:", error.message);
    }

    // Reject to ensure callers can handle in catch instead of receiving undefined
    return Promise.reject(error);
  }
);

export default axios;
